function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_oJpaIQomBDSILCrdnjOKPrBnr0aEgLe2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1000,
  height: 1000
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_oJpaIQomBDSILCrdnjOKPrBnr0aEgLe2)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 0 1000 L 1000 1000 L 1000 0 L 0 0 L 0 1000 Z ",
  fill: "rgb(0,194,203)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 0 556.556 L 0 1000 L 357.016 1000 L 625.528 800.951 L 550.09 699.189 L 430.621 787.75 L 364.392 698.408 L 600.12 523.661 L 535.441 436.413 L 625.528 369.632 L 550.09 267.868 L 460.004 334.649 L 403.028 257.79 L 0 556.556 Z ",
  fill: "rgb(255,87,87)"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_uiYgYpfDG45CrKanb6YJSoOoIblpZcwj"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 0 1000 L 1000 1000 L 1000 0 L 0 0 L 0 1000 Z ",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_uiYgYpfDG45CrKanb6YJSoOoIblpZcwj)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 372.191 408.907 C 372.191 408.907 369.466 293.393 408.152 251.438 C 446.839 209.483 457.736 195.316 554.724 196.951 C 651.712 198.586 668.059 254.708 668.059 254.708 C 668.059 254.708 717.097 355.51 637.001 481.921 C 637.001 481.921 621.199 520.062 540.013 611.056 L 472.448 691.153 L 622.289 691.153 C 622.289 691.153 637.546 686.795 637.001 700.961 C 636.456 715.128 627.738 795.769 627.738 795.769 C 627.738 795.769 628.282 803.398 615.751 803.398 L 334.594 803.398 C 334.594 803.398 322.607 805.032 322.607 788.141 L 322.607 733.109 C 322.607 733.109 320.972 720.577 332.96 703.685 C 344.947 686.795 361.293 662.82 361.293 662.82 L 526.391 449.228 C 526.391 449.228 590.141 357.144 561.263 319.548 C 561.263 319.548 536.814 290.125 500 321.727 C 500 321.727 483.345 335.894 477.352 381.664 L 475.717 405.638 C 475.717 405.638 476.262 421.439 466.999 421.984 C 457.736 422.529 383.088 421.984 383.088 421.984 C 383.088 421.984 372.139 422.561 372.191 408.907 Z ",
  fill: "rgb(255,255,255)"
})));

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 1000 1000",
    width: "1000pt",
    height: "1000pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.446b52ff.svg";
export { ForwardRef as ReactComponent };